import ReactMarkdown from 'react-markdown';
import githubFlavoredMarkdown from 'remark-gfm';
import { MarkdownRenderContext } from './RenderContext';
import { IMarkdownRenderers } from './IMarkdownRenderers';

interface IProps {
	source: string;
}

export function Markdown({ source }: IProps) {
	return (
		<MarkdownRenderContext.Consumer>
			{(renderers: IMarkdownRenderers) => (
				<ReactMarkdown
					remarkPlugins={[githubFlavoredMarkdown]}
					components={renderers}
				>
					{source}
				</ReactMarkdown>
			)}
		</MarkdownRenderContext.Consumer>
	);
}
